export const global_breakpoint_lg = {
  "name": "--pf-v5-global--breakpoint--lg",
  "value": "992px",
  "var": "var(--pf-v5-global--breakpoint--lg)"
};
export default global_breakpoint_lg;